module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAApgAAAAECAYAAAFdDX9OAAAAAXNSR0IArs4c6QAAAH1JREFUaAXt1zEOgCAQBED4LM8wxl/Aa9Uekoudx1DCNjcULKVYBAgQIBAUqG9ujHEE89vFWmvXdkMbmMAj0Hs/QRAgQIAAgU8CVbtcu2mXaxsnuQW0y/n9+pLPXewGBDwoASQRAgQIJBJQphJdplEIECBAgAABAgQI/EngBqx5EuVuGvxSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lin4.png
// module id = 581
// module chunks = 2